import { render, staticRenderFns } from "./StyleConfigurator.vue?vue&type=template&id=3163c6b0"
import script from "./StyleConfigurator.vue?vue&type=script&lang=js"
export * from "./StyleConfigurator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports